import React from "react";
import Logo from "../../assets/common/logo.png";
import "./offers.scss";
import { Link } from "react-router-dom";
import MarryCard from "../../molecules/cards/MarryCard";
import VenorForm from "../../organisms/venorForm";

const GetOffers = () => {
  const marryData = [
    {
      id: 1,
      title: "Tell us what you need",
      des: "Describe the service that you are looking for. We will match your request with vendors who can best meet your request.",
      img: "https://www.arabiaweddings.com/sites/default/files/uploads/2020/10/01/image1.png",
    },
    {
      id: 1,
      title: "Receive quotes and select a company",
      des: "Get quotes from trusted companies and professionals. Compare rates before hiring a service.",
      img: "https://www.arabiaweddings.com/sites/default/files/uploads/2020/10/01/image2.png",
    },
    {
      id: 1,
      title: "Sit back and relax",
      des: "Confirm the details of the product/service with the company you selected without the typical wedding planning stress.",
      img: "https://www.arabiaweddings.com/sites/default/files/uploads/2020/10/01/image3.png",
    },
  ];
  return (
    <>
      <div className="container">
        <div className="row">
          <div className="col-12 text-center d-flex justify-content-center">
            <Link to="/" className="logo_offers">
              <img src={Logo} alt="Logo" />
            </Link>
          </div>
        </div>
      </div>

      <div className="landing_intro">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center d-flex justify-content-center">
              <h2>Getting married? Save ​your ​time &amp; effort​</h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container my-3">
        <div className="row">
          {marryData &&
            marryData.map((card, index) => (
              <div key={index} className="col-md-4">
                <MarryCard img={card.img} title={card.title} des={card.des} />
              </div>
            ))}
        </div>
        <div className="row">
            <div className="col-12">

            <VenorForm />
            </div>
          {/* <div className="col-md-12">
            <h2 className="mt-4">Who Do You Want to Receive Offers from?</h2>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="veding_venu"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="veding_venu">
                Wedding Venue{" "}
              </label>
            </div>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="veding_planer"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="veding_planer">
                Wedding Planner{" "}
              </label>
            </div>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="veding_photography"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="veding_photography">
                Wedding Photography{" "}
              </label>
            </div>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="flowers"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="flowers">
                Flowers{" "}
              </label>
            </div>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="catering"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="catering">
                Chocolates, Wedding Cakes & Catering{" "}
              </label>
            </div>

            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="invitation"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="invitation">
                Invitation Cards{" "}
              </label>
            </div>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="dress"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="dress">
                Wedding Dress{" "}
              </label>
            </div>

            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="decor"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="decor">
                Furniture & Decor Rentals{" "}
              </label>
            </div>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="favors"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="favors">
                Wedding Favors{" "}
              </label>
            </div>
            <div className="offer_input my-2">
              <input
                type="checkbox"
                id="honeymoon"
                name=""
                value="1"
                class="form-checkbox"
              />
              <label class="option" for="honeymoon">
                Honeymoon{" "}
              </label>
            </div>
            <div className="form_input my-3">
              <label for="edit-field-user-fname-und-0-value">
                First Name{" "}
                <span class="form-required" title="This field is required.">
                  *
                </span>
              </label>
              <input class="form-control form-text required" type="text" id="edit-field-user-fname-und-0-value" name="field_user_fname[und][0][value]" value="" size="60" maxlength="255"></input>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default GetOffers;
